"use client";

import { useAppDispatch, useAppSelector } from "@/lib/redux/hooks";
import { thunks } from "@/lib/redux/thunks";
import { useEffect, useMemo } from "react";

// Module-level (không phải React state/ref) — cùng lý do với `useEsimCatalogFilters`: chặn nhiều
// component mount cùng lúc (Phổ biến/Quốc gia/Khu Vực trong EsimHubTabs) cùng bắn request trước khi
// Redux `called` kịp cập nhật.
let hasRequestedEsimCountries = false;

/**
 * 267 quốc gia + 6 châu lục thật từ `POST /esim/countries` (api_guide mục 0.3) — bật lại riêng cho
 * EsimHubTabs (tab Quốc gia/Khu Vực). Không đụng `SelectCountryCode`/form search cũ, vẫn dùng thư viện
 * mã quốc gia cục bộ (`getEsimCountries()`) như trước. Luôn lấy bản tiếng Việt (không truyền
 * `language_code`, BE mặc định 'vi') — khớp convention hiện tại của `getEsimCountries()` (cũng hardcode
 * 'vi' bất kể `i18n.language`).
 */
export const useEsimCountriesData = () => {
  const dispatch = useAppDispatch();
  const { countries, extra, loading, called } = useAppSelector((state) => ({
    countries: state.esim.esim_countries.data.countries,
    extra: state.esim.esim_countries.data.extra,
    loading: state.esim.esim_countries.loading,
    called: state.esim.esim_countries.called,
  }));

  useEffect(() => {
    if (called || hasRequestedEsimCountries) return;
    hasRequestedEsimCountries = true;
    dispatch(thunks.esim_countries({ body: { TYPE: "JSON" } }));
  }, [called, dispatch]);

  const continents = useMemo(
    () => [...(extra?.continent_country ?? [])].sort((a, b) => a.priority_id - b.priority_id),
    [extra],
  );

  return { countries, continents, loading };
};
